import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAxiosCookies } from '../../services/api';
import { clearAllCookies } from '../../utils/cookieUtils';

const TokenExpiredPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Limpar todos os dados de autenticação
    const clearAuthData = () => {
      // Limpar localStorage
      localStorage.removeItem('admin_user');
      localStorage.removeItem('admin_places');
      localStorage.removeItem('admin_current_place');
      
      // Limpar cookies
      clearAllCookies();
      clearAxiosCookies();
    };

    clearAuthData();

    // Redirecionar para login após 3 segundos
    const timer = setTimeout(() => {
      navigate('/login', { replace: true });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 text-red-500">
            <svg
              className="h-full w-full"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Sessão Expirada
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Sua sessão expirou por inatividade ou por questões de segurança.
          </p>
          <p className="mt-2 text-sm text-gray-600">
            Você será redirecionado para a página de login em alguns segundos.
          </p>
        </div>
        
        <div className="mt-8">
          <button
            onClick={() => navigate('/login', { replace: true })}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Ir para Login
          </button>
        </div>

        <div className="mt-6 text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-500 mx-auto"></div>
          <p className="mt-2 text-xs text-gray-500">Redirecionando...</p>
        </div>
      </div>
    </div>
  );
};

export default TokenExpiredPage;
